import React from 'react';
import Admin from '@this/components/admin/admin';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { createTheme } from '@this/constants/themes';
import ErrorBoundary from '@this/shared/error_boundary/error_boundary';
import AdminGoogleSignIn from '@this/components/admin/admin_google_sign_in/admin_google_sign_in';
import useApi from '@this/shared/hooks/use_api';
import { ConfirmModalContainer } from '@this/shared/ui/feedbacks/modal/confirm_modal';
import { AITThemeProvider } from '@this/shared/ui/theme';
import AdminContext from './context';

export const AdminRoot = () => {
  const { data, isLoading } = useApi<{ service_id: number; me: any }>('/admin/me');
  const serviceId = data?.service_id ?? 1;
  const theme = createTheme(serviceId);

  if (isLoading) {
    return null;
  }

  return (
    <ErrorBoundary>
      <HelmetProvider>
        <AITThemeProvider theme={theme}>
          <ConfirmModalContainer>
            <AdminContext.Provider value={serviceId}>
              <BrowserRouter>
                <Switch>
                  <Route exact path="/admins/sign_in" render={() => <AdminGoogleSignIn serviceId={serviceId} />} />
                  <Route path="/admin" component={Admin} />
                </Switch>
              </BrowserRouter>
            </AdminContext.Provider>
          </ConfirmModalContainer>
        </AITThemeProvider>
      </HelmetProvider>
    </ErrorBoundary>
  );
};
